import { createRoot, render, StrictMode } from "@wordpress/element";
import { Wrapper } from "./wrapper";
import "./scss/style.scss";

const domElement = document.getElementById(
  window.wpmudev_cross_sell_data.dom_element_id
);

if (domElement) {
  if (createRoot) {
    createRoot(domElement).render(
      <StrictMode>
        <Wrapper />
      </StrictMode>
    );
  } else {
    render(
      <StrictMode>
        <Wrapper />
      </StrictMode>,
      domElement
    );
  }
}
